export default __webpack_public_path__ + "static/grenette-bold-italic-pro-0040084da7c9768f22e413d3891d76be.ttf";